import { render, staticRenderFns } from "./RegistriIVA.vue?vue&type=template&id=ecab91d8&"
import script from "./RegistriIVA.vue?vue&type=script&lang=js&"
export * from "./RegistriIVA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecab91d8')) {
      api.createRecord('ecab91d8', component.options)
    } else {
      api.reload('ecab91d8', component.options)
    }
    module.hot.accept("./RegistriIVA.vue?vue&type=template&id=ecab91d8&", function () {
      api.rerender('ecab91d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/RegistriIVA.vue"
export default component.exports